import { useEffect, useRef } from "react";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // If already in view (above the fold), reveal immediately.
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add("reveal-in");
            io.unobserve(el);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -6% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`reveal ${className}`}
      style={{ transitionDelay: `${delay}s` }}
      {...rest}
    >
      {children}
    </div>
  );
};

export const Overline = ({ children, className = "" }) => (
  <span
    className={`font-mono-x text-xs md:text-sm tracking-[0.25em] uppercase text-blue-400 ${className}`}
  >
    {children}
  </span>
);

export default Reveal;
